import { render } from "./BlockDiagram.vue?vue&type=template&id=52fd0e8e&scoped=true&ts=true"
import script from "./BlockDiagram.vue?vue&type=script&lang=ts"
export * from "./BlockDiagram.vue?vue&type=script&lang=ts"

import "./BlockDiagram.vue?vue&type=style&index=0&id=52fd0e8e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/attack-flow/attack-flow/src/attack_flow_builder/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52fd0e8e"]])

export default __exports__